import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IncentiveFormatBaseComponent } from './incentiveFormatBase.component';

@Component({
    'selector': 'incentive-format1',
    'standalone': true,
    template: `
        <div class="format1-container">
            <h2>{{ heading }}</h2>
            <ion-list>
                @for (incentive of incentives; track $index) {
                    <ion-item lines="full">
                        <ion-label class="ion-text-wrap">
                            <h3>{{ incentive.title }}</h3>
                            @if (incentive.line1) {
                                <p>{{ incentive.line1 }}</p>
                            }
                            @if (incentive.line2) {
                                <p>{{ incentive.line2 }}</p>
                            }
                            @if (incentive.note) {
                                <p class="note">{{ incentive.note }}</p>
                            }
                        </ion-label>
                    </ion-item>
                }
            </ion-list>
        </div>
    `,
    'styles': [
        `
        .note {
            font-style: italic;
            color: var(--ion-color-medium);
            margin-top: 8px;
        }
    `
    ],
    'imports': [ IonicModule ]
})
export class IncentiveFormat1Component extends IncentiveFormatBaseComponent {
    public override heading = 'Incentives - Classic List Format';

    // private foo() {
    //   this.incentives = [];
    // }
}
